import { create } from 'zustand';
import type { Lead, Person } from '@/types/leads';

interface State {
  selectedItem: Lead | Person | null;
  modalType: 'place' | 'person';
  modalOpen: boolean;
}

interface Actions {
  openPlaceModal: (lead: Lead) => void;
  openPersonModal: (person: Person) => void;
  closeModal: () => void;
  navigateToPlace: (placeId: string, places: Lead[]) => void;
  navigateToPerson: (personId: number, persons: Person[]) => void;
}

type Store = State & Actions;

export const useDashboardStore = create<Store>((set) => ({
  selectedItem: null,
  modalType: 'place',
  modalOpen: false,
  openPlaceModal: (lead) => set({ selectedItem: lead, modalType: 'place', modalOpen: true }),
  openPersonModal: (person) => set({ selectedItem: person, modalType: 'person', modalOpen: true }),
  closeModal: () => set({ modalOpen: false, selectedItem: null }),
  navigateToPlace: (placeId, places) => {
    const place = places.find((p) => p.id === placeId);
    if (place) set({ selectedItem: place, modalType: 'place' });
  },
  navigateToPerson: (personId, persons) => {
    const person = persons.find((p) => p.id === personId);
    if (person) set({ selectedItem: person, modalType: 'person' });
  },
}));
